<template>
  <div class="datetime-control">
    <div v-for="(group, index) in value" :key="index" :class="[`datetime-day-${index + 1}`]">
      <div class="form-group row">
        <label class="form-label col-md-2" :for="`whole-day-${index + 1}`">Whole-day event</label>
        <div class="col-md-2 pt-4">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              value
              :id="`whole-day-${index + 1}`"
              v-model="group.wholeday"
            />
          </div>
        </div>
        <div class="offset-md-4 col-md-4 text-right">
          <span class="delete-instance" @click="onClickDeleteDatetime(index)"><u>DELETE INSTANCE</u></span>
        </div>
      </div>
      <div class="form-group row">
        <label class="form-label col-md-2" :for="`startdate-${index + 1}`">Start Date/Time:</label>
        <div class="col-md-4">
          <input
            type="date"
            class="form-control"
            :id="`startdate-${index + 1}`"
            v-model="group.startdate"
            required
          />
        </div>
        <div class="col-md-3" v-if="group.wholeday == false">
          <input
            type="time"
            class="form-control"
            :id="`starthour-${index + 1}`"
            v-model="group.starthour"
            required
          />
        </div>
        <div class="col-md-3" v-if="group.wholeday == false">
          <input
            type="time"
            class="form-control"
            :id="`startminute-${index + 1}`"
            v-model="group.startminute"
            required
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="form-label col-md-2" :for="`enddate-${index + 1}`">End Date/Time:</label>
        <div class="col-md-4">
          <input
            type="date"
            class="form-control"
            :id="`enddate-${index + 1}`"
            v-model="group.enddate"
            required
          />
        </div>
        <div class="col-md-3" v-if="group.wholeday == false">
          <input
            type="time"
            class="form-control"
            :id="`endhour-${index + 1}`"
            v-model="group.endhour"
            required
          />
        </div>
        <div class="col-md-3" v-if="group.wholeday == false">
          <input
            type="time"
            class="form-control"
            :id="`endminute-${index + 1}`"
            v-model="group.endminute"
            required
          />
        </div>
      </div>
    </div>
    <AddContentButton color="#BD081C" @click="onClickAddDay">Add instance</AddContentButton>
  </div>
</template>

<script>
import AddContentButton from '@/components/AddContentButton';
export default {
	components: {
		AddContentButton
	},
	props: {
		value: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	methods: {
		onClickAddDay() {
			this.value.push({
        wholeday: false,
        startdate:'',
        starthour:'',
        startminute:'',
        enddate:'',
        endhour:'',
        endminute:''
			});
    },
    onClickDeleteDatetime(index) {
      this.value.splice(index, 1)
    }
	}
};
</script>

<style lang="scss">
.datetime-control {
  .datetime-title {
    color: #c32aa3;
    font-size: 1.125rem;
    font-weight: bold;
  }

  .form-control {
    border-radius: 0;
  }

  .delete-instance {
    font-size: 1.125rem;
    cursor: pointer;
  }
}
</style>
